import { useState } from 'react';
import { VisibilityOffOutlined as ImageHiddenIcon } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import isTouchDevice from '@/lib/utils/isTouchDevice';
import BackgroundBlurringOverlay from './BackgroundBlurringOverlay';
import OverlayContentWrapper from './OverlayContentWrapper';
import MobileRevealButton from './MobileRevealButton';

const ThumbnailBannerInappropriateContentOverlay = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) {
    return null;
  }

  return (
    <BackgroundBlurringOverlay>
      {isTouchDevice() ? (
        <Tooltip
          title={
            <FormattedMessage id="portfolio.challenge.thumbnail_header.sensitive_content_overlay.reveal_button" />
          }
        >
          <MobileRevealButton onClick={() => setIsDismissed(true)}>
            <ImageHiddenIcon />
          </MobileRevealButton>
        </Tooltip>
      ) : (
        <OverlayContentWrapper>
          <ImageHiddenIcon />
          <div className="button-wrapper">
            <Button onClick={() => setIsDismissed(true)}>
              <FormattedMessage id="portfolio.challenge.thumbnail_header.sensitive_content_overlay.reveal_button" />
            </Button>
          </div>
        </OverlayContentWrapper>
      )}
    </BackgroundBlurringOverlay>
  );
};

export default ThumbnailBannerInappropriateContentOverlay;
